import React from 'react';
import { Select } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import useCompanies from '../../../../../../queries/useCompanies';
import { companiesSelector } from '../../../../store/selectors';
import { setFilterState } from '../../../../store/actions';
import { filterNames } from '../../../../constants/common';

const SelectCompanies = ({ className }) => {
  const dispatch = useDispatch();
  const selectedCompanies = useSelector(companiesSelector);

  const { data: companies, isFetching } = useCompanies({
    staleTime: Infinity,
  });

  const handleChange = (value) => {
    dispatch(setFilterState({ filterName: filterNames.companies, value }));
  };

  return (
    <Select
      className={className}
      loading={isFetching}
      mode="multiple"
      defaultActiveFirstOption={false}
      allowClear={true}
      placeholder="Управляющая компания"
      value={companies ? selectedCompanies : []}
      optionFilterProp="searchtext"
      onChange={handleChange}
    >
      {companies?.map((company) => (
        <Select.Option
          key={company.id}
          value={company.id}
          searchtext={company.name}
        >
          {company.name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectCompanies;
